// extracted by mini-css-extract-plugin
export var askAiIcon = "_on-k";
export var category = "_on-a";
export var categoryHeader = "_on-f";
export var container = "_on-0";
export var group = "_on-b";
export var groupItems = "_on-g";
export var groupSeparator = "_on-l";
export var highlight = "_on-8";
export var loading = "_on-1";
export var noResults = "_on-3";
export var placeholder = "_on-2";
export var resultContent = "_on-5";
export var resultIcon = "_on-d";
export var resultItem = "_on-h";
export var resultMeta = "_on-9";
export var resultSubtitle = "_on-7";
export var resultSuffix = "_on-j";
export var resultTitle = "_on-6";
export var resultsList = "_on-4";
export var searchGroup = "_on-e";
export var selected = "_on-i";
export var subgroup = "_on-c";